import { render, staticRenderFns } from "./addVariable.vue?vue&type=template&id=5dc8aa5a&scoped=true"
import script from "./addVariable.vue?vue&type=script&lang=js"
export * from "./addVariable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc8aa5a",
  null
  
)

export default component.exports